import React from 'react';
import Skeleton from 'react-loading-skeleton';
import _ from 'lodash';

import 'react-loading-skeleton/dist/skeleton.css';

const DashboardWidgetSkeletonFile = () => {
  const random1 = _.random(20, 70);
  const random2 = _.random(40, 80);

  return (
    <div className="widget widget-grid-skeleton grid-item">
      <div className="grid-item-img-wrapper" />
      <div className="grid-item-body">
        <h5><Skeleton style={{ width: `${random1}%` }} /></h5>
        <p><Skeleton style={{ width: `${random2}%` }} /></p>
      </div>
    </div>
  );
};

export default DashboardWidgetSkeletonFile;
